import { c as _c } from "react/compiler-runtime";
import { motion, useMotionValue } from "framer-motion";
import Image from "next/image";
import { useRef } from "react";
import { ResponsiveDialog, ResponsiveDialogContent, ResponsiveDialogHeader, ResponsiveDialogTitle } from "@/components/ui/responsive-dialog";
import { cn } from "@/lib/utils";
interface PropModalProps {
  name: string;
  images: string[];
  howToRedeemHtml?: string | null;
  description?: string | null;
  isOpen: boolean;
  onClose: () => void;
}
export default function PropModal(t0) {
  const $ = _c(24);
  const {
    name,
    images,
    howToRedeemHtml,
    description,
    isOpen,
    onClose
  } = t0;
  const containerRef = useRef(null);
  const x = useMotionValue(0);
  if (!isOpen) {
    return null;
  }
  let t1;
  if ($[0] !== onClose) {
    t1 = open => !open && onClose();
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("text-left md:text-xl");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== name) {
    t3 = <ResponsiveDialogHeader><ResponsiveDialogTitle className={t2}>{name}</ResponsiveDialogTitle></ResponsiveDialogHeader>;
    $[3] = name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== images || $[6] !== name || $[7] !== x) {
    t4 = images && images.length > 0 && <div ref={containerRef} className={cn("cursor-grab active:cursor-grabbing", "mb-5 md:mb-4")}><motion.div className={cn("flex flex-row min-w-max", "gap-3    ")} drag="x" dragConstraints={containerRef} style={{
        x
      }} dragElastic={0.1} dragTransition={{
        bounceStiffness: 400,
        bounceDamping: 30
      }}>{images.map(img => <motion.div key={img} className="flex items-center justify-center flex-shrink-0"><Image src={img} alt={name} width={240} height={240} className={cn("object-contain select-none", "w-48 h-48 md:w-90 md:h-90")} draggable={false} /></motion.div>)}</motion.div></div>;
    $[5] = images;
    $[6] = name;
    $[7] = x;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== howToRedeemHtml) {
    t5 = howToRedeemHtml && <div className={cn("text-[#555] space-y-1   [&>h5]:mb-2 [&>h5]:text-base [&>h5]:font-medium [&>h5]:font-['DINPro-Medium'] [&>h5]:text-[#010101]", "text-xs md:text-sm mt-2")} dangerouslySetInnerHTML={{
      __html: howToRedeemHtml
    }} />;
    $[9] = howToRedeemHtml;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== description) {
    t6 = description && <><div className="my-3 md:my-4 border-t border-[#eee] h-px" /><p className="text-xs md:text-sm whitespace-pre-line text-[#010101]">{description}</p></>;
    $[11] = description;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className="flex-1 overflow-x-hidden md:overflow-y-auto">{t4}{t5}{t6}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t3 || $[18] !== t7) {
    t8 = <ResponsiveDialogContent className="h-auto flex flex-col max-h-[60dvh] md:max-h-unset md:w-[912px] md:max-w-[912px] md:px-12 md:pb-12  break-words">{t3}{t7}</ResponsiveDialogContent>;
    $[17] = t3;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== isOpen || $[21] !== t1 || $[22] !== t8) {
    t9 = <ResponsiveDialog open={isOpen} onOpenChange={t1}>{t8}</ResponsiveDialog>;
    $[20] = isOpen;
    $[21] = t1;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}